import * as Linking from 'expo-linking';
import { Platform } from 'react-native';

class ExternalLinkService {
  public readonly openUrl = (
    url: string,
    target: '_blank' | '_self' = '_blank'
  ) => {
    if (Platform.OS === 'web') {
      window.open(url, target);
    } else {
      Linking.openURL(url).then();
    }
  };
}

const externalLinkService = new ExternalLinkService();

export default externalLinkService;
